import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { createTemplate, deleteTemplate, launchTemplate, listTemplates } from '@/api/templates';
import type { TemplateConfig } from '@/types';

export function useTemplates() {
  return useQuery({ queryKey: ['templates'], queryFn: () => listTemplates() });
}

export function useCreateTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: { name: string; config: TemplateConfig }) => createTemplate(body),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['templates'] }),
  });
}

export function useDeleteTemplate() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (id: string) => deleteTemplate(id),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['templates'] }),
  });
}

export function useLaunchTemplate() {
  return useMutation({ mutationFn: (id: string) => launchTemplate(id) });
}
